// SF3 — which products the spend is carrying, and whether they still make
// money after it.
import React from 'react';
import s from '../AdsAnalytics.module.css';
import { money, pct, ratio, LABEL_TONE } from '../format';

export default function Products({ data, loading }) {
  if (loading && !data) return <div className={s.empty}>Loading…</div>;
  if (!data) return null;
  if (!data.rows?.length) {
    return <div className={s.empty}>No advertised products in this period.</div>;
  }
  const currency = data.currency;
  return (
    <>
      {data.note && <p className={s.hint} style={{ marginBottom: 12 }}>{data.note}</p>}
      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Product</th>
              <th className={s.right}>Spend</th>
              <th className={s.right}>Ad sales</th>
              <th className={s.right}>ACOS</th>
              {data.split_available && <>
                <th className={s.right}>Total sales</th>
                <th className={s.right}>TACOS</th>
                <th className={s.right}>From ads</th>
              </>}
              <th className={s.right}>Break-even</th>
              <th>Verdict</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.asin}>
                <td>
                  <span className={s.term}>{r.asin}</span>
                  {r.tags.map((t) => <span key={t} className={s.tag}>{t}</span>)}
                  {r.sales_other_products > 0 && (
                    <span className={s.subFigure}>
                      + {money(r.sales_other_products, currency)} of other products
                    </span>
                  )}
                </td>
                <td className={s.right}>{money(r.spend, currency)}</td>
                <td className={s.right}>{money(r.ad_sales, currency)}</td>
                <td className={s.right}>{ratio(r.acos, r.acos_reason)}</td>
                {data.split_available && <>
                  <td className={s.right}>{money(r.total_sales, currency)}</td>
                  <td className={s.right}>{ratio(r.tacos, r.tacos_reason)}</td>
                  <td className={s.right}>{pct(r.ad_share)}</td>
                </>}
                <td className={s.right}>
                  {r.break_even_acos == null
                    ? <span className={s.unknown}>{r.break_even_note}</span>
                    : pct(r.break_even_acos)}
                </td>
                <td>
                  <span className={`${s.verdict} ${s[LABEL_TONE[r.label] || 'muted']}`}
                        title={r.why}>{r.label}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className={s.hint} style={{ marginTop: 10 }}>
        Break-even ACOS needs a cost per product. Where none is stored the row says
        &ldquo;Add cost&rdquo; rather than estimating one — a break-even built on a guessed
        cost would tell a seller a losing product is profitable.
        {' '}Sales the ad drove for <em>other</em> products are shown apart, never merged into
        the advertised one.
      </p>
    </>
  );
}
